export const OPEN_CHAT = 'APP/ZENDESK/OPEN_CHAT'
export const CLOSE_CHAT = 'APP/ZENDESK/CLOSE_CHAT'
export const SHOW_CHAT_BUTTON = 'APP/ZENDESK/SHOW_CHAT_BUTTON'
export const HIDE_CHAT_BUTTON = 'APP/ZENDESK/HIDE_CHAT_BUTTON'
